var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('SimpleTable',{attrs:{"columns":_vm.columns,"data":_vm.tableData},scopedSlots:_vm._u([{key:"probingDate",fn:function(ref){
var value = ref.value;
return [_vm._v("\n      "+_vm._s(_vm.$i18n.format(value, 'date'))+"\n    ")]}}])}),_c('IxVectorLayer',{attrs:{"features":_vm.pointFeatures,"vector-style":_vm.styles.point,"layer-id":"points"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }